<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="exercises" #cardHolder>
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
      <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
        <ng-container side>
          <app-exercises-filter [filterList]="filters"
          [selectedFilter]="selectedFilter"
          (selectFilter)="selectFilter($event)"></app-exercises-filter>
        </ng-container>

      </app-library-title>
      <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link"
                           [pane]="_pane"></app-library-sorting>
    </div>

    <div class="carousel">
      <ng-template [ngIf]="showCarousel">
        <div class="right-btn" (click)="moveRight()">
          <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
        </div>

        <div class="left-btn" (click)="moveLeft()">
          <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
        </div>
      </ng-template>

      <div class="scroll-viewport" #scroller>
        <div *ngFor="let content of filteredContent(); let i = index; trackBy: trackContentByFn"
             class="scroll-item infinity-item item{{itemsPerRow}}"
             [ngStyle]="{ 'flex-basis' : defaultItemsWidth + 'px'}"
             (click)="onOpenCard(i)">
            <ng-template [ngIf]="cardType === 'vertical'">
              <app-vertical-card [content]="content"></app-vertical-card>
            </ng-template>
            <ng-template [ngIf]="cardType === 'vertical-square'">
              <app-vertical-square-card [content]="content"></app-vertical-square-card>
            </ng-template>
            <ng-template [ngIf]="cardType === 'horizontal'">
              <app-horizontal-card [content]="content"></app-horizontal-card>
            </ng-template>
            <ng-template [ngIf]="cardType === 'wide-vertical'">
              <app-wide-vertical-card [content]="content"></app-wide-vertical-card>
            </ng-template>
            <ng-template [ngIf]="cardType === 'wide-horizontal'">
              <app-wide-horizontal-card [content]="content"></app-wide-horizontal-card>
            </ng-template>

        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-modal *ngIf="!deviceService.isMobile() && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <app-content-card
      class="modal"
      [item_id]="item.id"
      [show]="openedCardIndex !== null"
      [showSkeleton]="false"
      [canClose]="false"
      [inline]="false"
      [active]="false"
      [meta]="true"
      (close)="onCloseCard()">
    </app-content-card>
  </app-modal-body>
</app-modal>
<app-mobile-modal *ngIf="deviceService.isMobile() && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <div class="card">
      <app-content-card
        [item_id]="item.id"
        [show]="openedCardIndex !== null"
        [showSkeleton]="false"
        [canClose]="false"
        [inline]="false"
        [active]="false"
        [meta]="true"
        [displayMode]="'content_page'"
        (close)="onCloseCard()">
      </app-content-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
